<template>
  <div class="social-media-share-component">
    <ul class="list-inline social-media-links pt-2">
      <li class="list-inline-item" v-if="instagramUrl !== undefined">
          <a :href="instagramUrl" target="_blank">
              <span class="fa-stack fa-2x">
                  <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                  <i class="fab fa-instagram fa-stack-1x"></i>
              </span>
          </a>
      </li>
      <li class="list-inline-item" v-if="facebookUrl !== undefined">
          <a :href="facebookUrl" target="_blank">
              <span class="fa-stack fa-2x">
                  <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                  <i class="fab fa-facebook-f fa-stack-1x"></i>
              </span>
          </a>
      </li>
      <li class="list-inline-item" v-if="twitterUrl !== undefined">
          <a :href="twitterUrl" target="_blank">
              <span class="fa-stack fa-2x">
                  <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                  <i class="fab fa-twitter fa-stack-1x"></i>
              </span>
          </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SocialMediaShare',
  props: {
    facebookUrl: String,
    instagramUrl: String,
    twitterUrl: String
  }
}
</script>

<style lang="sass" scoped>
.social-media-links a
  color: $dutche-primary-violet

.social-media-links a:hover
  color: $dutche-primary-orange

.social-media-links .fas
  color: $dutche-primary-yellow

.social-media-links .fa-2x
  font-size: 2.1em
</style>
